import { Button, Card, StatusInfo } from '@george-labs.com/design-system';
import type { FC } from 'react';

import { t } from '@luna/i18n';

interface Props {
    overviewAbsolutePath: string;
}
export const BankMessageDetailsNotFoundError: FC<Props> = ({ overviewAbsolutePath }) => (
    <Card>
        <StatusInfo
            preferIllustration
            data-cy="bank-message-not-found-error"
            variant={StatusInfo.VARIANT.ERROR}
            title={t('bankMessages.details.bankMessageNotFoundErrorTitle')}
            buttons={[
                <Button
                    key="navigate-to-dashboard"
                    data-cy="go-back-to-dashboard"
                    href={overviewAbsolutePath}
                >
                    {t('bankMessages.details.navigateToOverviewButton')}
                </Button>,
            ]}
        >
            {t('bankMessages.details.bankMessageNotFoundErrorText')}
        </StatusInfo>
    </Card>
);
